var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "complaint-container clearfix swb-back-row" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("发起投诉")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "complaint-content mr15 mt10",
          staticStyle: { "margin-left": "0" }
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("投诉信息")]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: { model: _vm.complaintInfo, rules: _vm.rules }
            },
            [
              _c("div", { staticClass: "simple-form" }, [
                _vm.isNotVoucher
                  ? _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("投诉主题类型")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function($event) {
                                  _vm.getComplaintTypeList(_vm.model)
                                }
                              },
                              model: {
                                value: _vm.model,
                                callback: function($$v) {
                                  _vm.model = $$v
                                },
                                expression: "model"
                              }
                            },
                            _vm._l(_vm.subjectTypeList, function(type, value) {
                              return _c(
                                "el-radio",
                                { attrs: { label: type.value } },
                                [_vm._v(_vm._s(type.text))]
                              )
                            })
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("投诉类型")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "typeId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.complaintInfo.typeId,
                                callback: function($$v) {
                                  _vm.$set(_vm.complaintInfo, "typeId", $$v)
                                },
                                expression: "complaintInfo.typeId"
                              }
                            },
                            _vm._l(_vm.complaintTypeList, function(item) {
                              return _c("el-option", {
                                attrs: { label: item.name, value: item.id }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("问题描述")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "content" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", placeholder: "请输入" },
                            model: {
                              value: _vm.complaintInfo.content,
                              callback: function($$v) {
                                _vm.$set(_vm.complaintInfo, "content", $$v)
                              },
                              expression: "complaintInfo.content"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("处理要求")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "demand" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", placeholder: "请输入" },
                            model: {
                              value: _vm.complaintInfo.demand,
                              callback: function($$v) {
                                _vm.$set(_vm.complaintInfo, "demand", $$v)
                              },
                              expression: "complaintInfo.demand"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("联系人姓名")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactName" } },
                        [
                          _c("el-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.complaintInfo.contactName,
                              callback: function($$v) {
                                _vm.$set(_vm.complaintInfo, "contactName", $$v)
                              },
                              expression: "complaintInfo.contactName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("联系人电话")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactTel" } },
                        [
                          _c("el-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.complaintInfo.contactTel,
                              callback: function($$v) {
                                _vm.$set(_vm.complaintInfo, "contactTel", $$v)
                              },
                              expression: "complaintInfo.contactTel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("联系人邮箱")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contactEmail" } },
                        [
                          _c("el-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.complaintInfo.contactEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.complaintInfo, "contactEmail", $$v)
                              },
                              expression: "complaintInfo.contactEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-3x" },
                [
                  _c("swb-file-upload", {
                    attrs: {
                      fileGroup: "file-misc",
                      fileFor: "solution",
                      onBeforeUpload: _vm.onBeforeUpload,
                      onProgress: _vm.onProgress,
                      onDone: _vm.onUploadDone,
                      multipleFile: true
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "file-area clearfix" },
                    _vm._l(_vm.complaintFileList, function(
                      complaintFile,
                      index
                    ) {
                      return _c("div", { staticClass: "mr15 inline-block" }, [
                        complaintFile.fileExtName == "jpg" ||
                        complaintFile.fileExtName == "png" ||
                        complaintFile.fileExtName == "jpeg" ||
                        complaintFile.fileExtName == "JPEG"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "file-item show-usage image deletable viewable downloadable editable"
                              },
                              [
                                _c("div", { staticClass: "file-content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "usage ellipsis-1" },
                                    [_vm._v(_vm._s(complaintFile.fileName))]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: { src: complaintFile.fileBrowseUrl }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "operation-group" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon iconfont icon-chakan view",
                                        on: {
                                          click: function($event) {
                                            _vm.viewImage(
                                              complaintFile.fileBrowseUrl
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "delete-icon",
                                    on: {
                                      click: function($event) {
                                        _vm.removeUpload(index)
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "file-item show-usage deletable viewable downloadable editable"
                              },
                              [
                                _c("div", { staticClass: "file-content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "usage ellipsis-1" },
                                    [_vm._v(_vm._s(complaintFile.fileName))]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: { src: complaintFile.fileBrowseUrl }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "operation-group" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon iconfont icon-xiazai download",
                                        on: {
                                          click: function($event) {
                                            _vm.downloadFile(
                                              complaintFile.fileUuid
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "delete-icon",
                                    on: {
                                      click: function($event) {
                                        _vm.removeUpload(index)
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                      ])
                    })
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-toolbar" }, [
            _c(
              "button",
              {
                staticClass: "swb-btn mr30",
                on: {
                  click: function($event) {
                    _vm.$router.back(-1)
                  }
                }
              },
              [_vm._v("取消投诉")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "swb-btn mr20",
                on: {
                  click: function($event) {
                    _vm.saveComplaint()
                  }
                }
              },
              [_vm._v("发起投诉")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isNotVoucher &&
      _vm.complaintorderOrderInfo != null &&
      _vm.complaintorderOrderInfo.id != null
        ? _c("div", { staticClass: "order-info mt10" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("订单信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "order-content" }, [
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("订单编号：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right font-blue" }, [
                  _vm._v(_vm._s(_vm.complaintorderOrderInfo.no))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("总计：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right font-red" }, [
                  _vm._v(_vm._s(_vm.complaintorderOrderInfo.amount) + "元")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("提交时间：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v(_vm._s(_vm.complaintorderOrderInfo.submitTime))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("商家：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right font-blue" }, [
                  _vm._v(_vm._s(_vm.complaintorderOrderInfo.sellerName))
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isNotVoucher && _vm.model != 0
        ? _c("div", { staticClass: "order-info mt10" }, [
            _c("h4", { staticClass: "title" }, [
              _c("span", [_vm._v("被投诉商家")]),
              _c(
                "a",
                {
                  staticClass: "swb-btn-link fr",
                  staticStyle: { "margin-top": "7px" },
                  on: {
                    click: function($event) {
                      _vm.chooseBusiness()
                    }
                  }
                },
                [_vm._v("选择被投诉商家")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "order-content" }, [
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("商户名称：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right font-blue" }, [
                  _vm._v(_vm._s(_vm.merchantBizRel.peerMerchantName))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("开始日期：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v(_vm._s(_vm.merchantBizRel.dateStart))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("截止日期：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v(_vm._s(_vm.merchantBizRel.dateEnd))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("星级标记：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right font-blue" }, [
                  _vm.merchantBizRel.starLevel == 0
                    ? _c("span", { staticClass: "font-red" }, [
                        _vm._v("待入围")
                      ])
                    : _c("span", { staticClass: "font-black" }, [
                        _vm._v(_vm._s(_vm.merchantBizRel.starLevel))
                      ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("上传附件")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-511b3d07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-511b3d07","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/custsvc/ComplaintSave.vue
// module id = 2712
// module chunks = 0